export interface DeleteAccountErrorReason {
  entity_ids: string[];
}

export interface DeleteAccountErrorData {
  error: string;
  reason: DeleteAccountErrorReason;
}

export interface DeleteAccountApiError {
  error: {
    data: {
      errors: DeleteAccountErrorData;
    };
  };
}

export function isDeleteAccountApiError(
  res: unknown
): res is DeleteAccountApiError {
  const errors = (res as DeleteAccountApiError)?.error?.data.errors;

  return (
    typeof errors?.error === "string" &&
    typeof errors?.reason === "object" &&
    Array.isArray(errors?.reason?.entity_ids)
  );
}
